import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { UseCaseData } from "../types/use-case.types"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { toggleVote } from "../api/use-cases-api"

export function useVoteUseCase() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (useCaseId: string) => toggleVote(useCaseId),
    onMutate: async (useCaseId) => {
      await queryClient.cancelQueries({ queryKey: useCasesQueryKeys.list() })

      const previous = queryClient.getQueryData<UseCaseData[]>(useCasesQueryKeys.list())

      queryClient.setQueryData<UseCaseData[]>(useCasesQueryKeys.list(), (old) =>
        old?.map((uc) =>
          uc.id === useCaseId
            ? {
                ...uc,
                hasVoted: !uc.hasVoted,
                voteCount: (uc.voteCount ?? 0) + (uc.hasVoted ? -1 : 1),
              }
            : uc
        )
      )

      return { previous }
    },
    onError: (_err, _id, context) => {
      if (context?.previous) {
        queryClient.setQueryData(useCasesQueryKeys.list(), context.previous)
      }
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.list() })
    },
  })
}
